import Link from "next/link";
import AppLogo from "@/components/ui/AppLogo";
import Icon from "@/components/ui/AppIcon";

export default function Footer() {
  return (
    <footer className="bg-navy-dark text-white border-t border-navy-light/20">
      <div className="max-w-8xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <AppLogo
                src="/assets/images/ChatGPT_Image_2026_2_12_09_54_36-1771749634557.png"
                size={48}
              />
              <div>
                <div className="font-heading font-black text-lg leading-tight">
                  <span className="text-orange">PC</span>{" "}
                  <span className="text-white">CARGO</span>
                </div>
                <div className="text-xs text-white/50 tracking-widest uppercase">
                  LIMITED
                </div>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              香港及台灣電腦零件貿易專家。<br />
              Your trusted partner for B2B computer parts trading across Asia and beyond.
            </p>
            <div className="flex items-center gap-2 text-sm text-white/60">
              <Icon name="MapPinIcon" size={14} className="text-orange flex-shrink-0" />
              <span>香港觀塘海濱道139號, Kowloon</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-white/60 mt-2">
              <Icon name="DevicePhoneMobileIcon" size={14} className="text-orange flex-shrink-0" />
              <a href="https://wa.me/85259773386" className="hover:text-orange transition-colors">
                +852 5977 3386
              </a>
            </div>
            <div className="flex items-center gap-2 text-sm text-white/60 mt-2">
              <Icon name="EnvelopeIcon" size={14} className="text-orange flex-shrink-0" />
              <a href="mailto:andy1oo5@pccargohk.com" className="hover:text-orange transition-colors">
                andy1oo5@pccargohk.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h5 className="text-xs font-black uppercase tracking-widest mb-5 text-orange">
              Navigation
            </h5>
            <ul className="space-y-3 text-sm text-white/60">
              <li><Link href="/homepage" className="hover:text-orange transition-colors">首頁 Home</Link></li>
              <li><Link href="/products" className="hover:text-orange transition-colors">產品 Products</Link></li>
              <li><Link href="/contact" className="hover:text-orange transition-colors">聯絡 Contact</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div className="md:col-span-3">
            <h5 className="text-xs font-black uppercase tracking-widest mb-5 text-orange">
              Product Categories
            </h5>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="hover:text-white/90 transition-colors cursor-pointer">CPU 處理器</li>
              <li className="hover:text-white/90 transition-colors cursor-pointer">GPU 顯示卡</li>
              <li className="hover:text-white/90 transition-colors cursor-pointer">RAM 記憶體</li>
              <li className="hover:text-white/90 transition-colors cursor-pointer">Motherboard 主機板</li>
              <li className="hover:text-white/90 transition-colors cursor-pointer">Storage 儲存裝置</li>
            </ul>
          </div>

          {/* Contact CTA */}
          <div className="md:col-span-3 bg-white/5 border border-white/10 rounded-3xl p-7">
            <h5 className="text-base font-black mb-2">批量採購詢價</h5>
            <p className="text-white/60 text-sm mb-5">Bulk order inquiries welcome. Contact us via WhatsApp for fastest response.</p>
            <a
              href="https://wa.me/85259773386"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-orange hover:bg-orange-dark transition-colors text-white py-3 px-5 rounded-full font-bold text-sm w-full"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={16} variant="solid" />
              WhatsApp Now
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            © 2026 PC CARGO LIMITED. All rights reserved. 版權所有
          </p>
          <div className="flex gap-6 text-xs text-white/40">
            <span className="hover:text-white/70 transition-colors cursor-pointer">Privacy Policy</span>
            <span className="hover:text-white/70 transition-colors cursor-pointer">Terms of Service</span>
            <span className="text-white/20">|</span>
            <span>Hong Kong · Taiwan</span>
          </div>
        </div>
      </div>
    </footer>
  );
}